// Vrai dès qu'une authentification fraîche a eu lieu pendant ce chargement de page :
// le démarrage à froid ne doit alors pas reverrouiller (ex. connexion Face ID puis navigation vers '/').
let unlocked = false;

export function markUnlockedThisLoad() {
  unlocked = true;
}

export function isUnlockedThisLoad() {
  return unlocked;
}

export function resetUnlockedForTests() {
  unlocked = false;
}
